export enum Messages {
    Dialog_Message_Error = 'Unable to process the request. Please try again after sometime',
    Dialog_Authentication_Error = 'Unable to process the request. Please try again after sometime. Do you want to logout?',
    Dialog_Timeout_Message_Error = 'Network timeout. Please try again after sometime',
    Dialog_Confirmation_Button_Confirm_Discard = 'Are you sure you want to discard?',
    Mandatory_Fields_Validation = 'Enter Mandatory Details',
    Dialog_Title = 'Message',
    Dialog_History_Title = 'View Action History',
    Dialog_Button_Ok = 'Ok',
    Dialog_Button_Close = 'Close',
    Dialog_Button_Cancel = 'Cancel',
    Dialog_Confirmation_Title = 'Confirmation',
    Dialog_Confirmation_Delete_Message = 'Are you sure you want to delete?',
    Dialog_Confirmation_Button_Title_First = 'Yes',
    Dialog_Confirmation_Button_Title_Second = 'No',
    Unsaved_Changes_Alert = 'Unsaved changes present. Please save or discard them to continue',
    Unsaved_Changes_Confirmation = '<div>You have unsaved changes that will be lost.</div><div>Do you still want to continue?</div>',
    Only_Number_Validation = 'Enter only number in this field',
    Numeric_Values_Allowed = 'Only positive numbers are allowed',
    Email_Validation = 'Enter proper email format',
    Project_Req_Validation_A_FS = 'Please fill the required fields in Activity and Funding Source tabs',
    Project_Validation_Activity_Tab = 'Please fill the required fields in Activity tab',
    Project_Validation_Funding_Source_Tab = 'Please fill the required fields in Funding Source tab',
    Project_Validation_Block_Lot_Tab = 'Please fill the required fields in Block Lot tab',
    Email_Domain_Validation = 'Only e-mail addresses in nycsca.org domain are allowed',
    Max_Length_Validation = 'Maximum characters allowed is ',
    Min_Length_Validation = 'Minimum characters allowed is ',
    Max_Length_Validation_int = 'Maximum digits allowed is ',
    Required_Validation = 'This is a required field',
    Type_Validation = 'Incorrect data type',
    Invalid_Date_Entered = 'Invalid date entered',
    No_Responsibility_Selected= 'No Responsibility selected',
    No_Code_Category_Selected= 'No Code Category selected',
    UnAuthorizedAccess = 'You are not authorized to use this application',
    Session_Timeout_Warning = 'Your session will expire in 2 minutes. Would you like to continue your session?',
    SignOutButton = 'Sign Out',
    Invalid_Browser = 'This site is accessible in Chrome browser only',
    Invalid_Funding_Source_Code = 'The first 3/4 characters must be equal to plan category, plan sub category and sequence',
    No_Plan_Category_Selected= 'No Plan Category selected',
    No_Sub_Category_Selected= 'No Plan Sub Category selected',
    No_Checkbox_Selected_LLW_Create = 'Please select project to Create LLW',
    Deactivate_User = 'Are you sure you want to Deactivate?',
    Add_User_Responsibility = 'System will expire the current responsibility before adding new one. Do you wish to continue?',
    Invalid_Project_No = 'Invalid Project Number',
    Invalid_Fe_Category_Code = 'F&E Only is not valid for DOE managed projects',
    Invalid_Managed_By = 'DOE is not valid for F&E Only projects',
    Temp_Swb_Installed = 'Temporary SWB Installed',
    Swb_Corrective_Work = 'SWB Corrective Work',
    Project_Num_Format = 'Field must be of form xxx9999999999',
    Plan_Num_Format = 'Field must be of form 9.XXX',
    Req_Date_Range_Error = 'Date must be in range 01/01/1989 to 12/31/2020',
    Enable_Action = 'Are you sure you want to Enable?',
    Disable_Action = 'Are you sure you want to Disable?',
    Year_Fields_Format = 'Field must be of form 9999',
    Bad_Exponent_Message = 'Bad Exponent',
    Digit_Precision_Message = 'Too many digits preceding decimal point for scientific notation',
    Project_Amount_Validation_FS_AA= 'The Total of your funding source is not equal to your activity amount, Please correct',
    Project_Adjust_FS = 'Adjust Funding Source',
    Project_Back_To_AA = 'Back to Activity Amount',
    Project_Date_Range = 'Date must be in range 01/01/1989 to 12/31/',
    Plan_Year_Range = 'Plan year must be in the range of 2009 to 2025',
    Dialog_Continue_Button = 'Continue',
    Dialog_Cancel_Button = 'Cancel',
    Logout_Dialog_Button_Cancel = 'Cancel',
    Logout_Confirmation = 'Are you sure you want to logout?',
    Duplicate_Activity_Type = 'Record with same activity is already added. Please change the Activity',
    Duplicate_Funding_Source = 'Record with same funding source code is already added. Please change the Funding Source Code',
    Duplicate_Capital_Node = 'Record with same capital node is already added. Please change the Capital Node',
    Duplicate_Cp_Number = 'Record with same CP Number is already added. Please change the CP Number',
    Duplicate_Tag_Code = 'Record with same tag is already added. Please change the Tag',
    Block_Field_Length = 'Block field length should not be greater than 5',
    Lot_Field_Length = 'Lot field length should not be greater than 4',
    Cp_Number_Format = 'Field must be of form 99AAAAA',
    Project_Type_Disable_Message = 'Can not set ENABLED attribute of current Project Type',
    ProjectAlreadyDisposed = 'Record has been updated by another user, Re-query to see change.',
    Llw_Report_Start_Date_Check = 'Start Date should not be empty',
    Llw_Report_End_Date_Check = 'End Date should not be empty',
    Llw_Report_Compare_Dates= 'Start Date should be less than or equal to End Date',
    Project_Num_Truncation = 'Truncation occurred: value too long for Project Number field',
    Login_Failure_Message = 'Unable to login. Please try again after sometime',
    Auth_Token_Failure_Message = '<div>Unable to acquire access token. It could be because of your browser settings, please allow cookies by selecting "Allow all cookies" and try again.</div><div>Application will be redirected to Sign-In screen</div>',
    Plan_Cat_Max_Length_Message = 'Maximum characters allowed in Plan Category is 1',
    Plan_Cat_Descp_Max_Length_Message = 'Maximum characters allowed in Plan Category Description is 50',
    Numeric_Values_Validation_Message = 'Only numeric values allowed',
    Project_Num_Mandatory_Message = 'Enter project number',
    Requestor_Mandatory_Message = 'Please select requestor',
    Plan_Category_Validation_Message = 'Please enter Plan Category',
    Amount_Pattern_Message = 'Field must be of form $ 999,999,999.99',
    AzureException = 'Root segment cannot have matrix parameters',
    Invalid_Capital_Category_Code = 'The first 3/4 characters must be equal to plan category, plan sub category and sequence',
    Required_Fields = 'required field(s):'
}



